/**
 * Apple WeatherKit requires visible attribution wherever its data is shown:
 * the "Weather" trademark plus a link to Apple's data-sources / legal page.
 * https://developer.apple.com/weatherkit/get-started/ (Attribution Requirements)
 *
 * The legal link must read as a link on its own (App Review rejected 0.0.38
 * under 5.2.5 when the whole mark was a silent tap target), so it's a
 * separate, underlined "Legal" next to the mark.
 */
const LEGAL_ATTRIBUTION_URL = 'https://weatherkit.apple.com/legal-attribution.html'

// Apple logo glyph (U+F8FF) — renders as the Apple mark on Apple platforms (this
// is iOS-only). Escaped: the raw private-use character gets stripped by tooling.
const APPLE_WEATHER_LABEL = '\uF8FF Weather'

interface WeatherAttributionProps {
  /** Text color class (defaults to a subtle token). */
  className?: string
}

export function WeatherAttribution({ className = 'text-content-primary-subtle' }: WeatherAttributionProps) {
  return (
    <div className={`flex items-center gap-1.5 self-end text-[11px] leading-4 ${className}`}>
      <span>{APPLE_WEATHER_LABEL}</span>
      <span aria-hidden>·</span>
      <a
        href={LEGAL_ATTRIBUTION_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          // Cards around this are tappable — keep the tap on the link
          e.stopPropagation()
          e.preventDefault()
          window.open(LEGAL_ATTRIBUTION_URL, '_blank', 'noopener,noreferrer')
        }}
        className="underline underline-offset-2"
      >
        Legal
      </a>
    </div>
  )
}
